<template>
  <v-footer padless>
    <v-col
      class="text-center"
      cols="3"
    >
      {{ new Date(todaysDate).getFullYear() }} — <strong>TM Consulting</strong>
    </v-col>
    <v-col
      class="text-center"
      cols="2"
    >
      <v-btn
        class="ma-2"
        outlined
        color="indigo"
        @click="printScreen"
      >
        PRINT SCREEN
      </v-btn>
    </v-col>
    <v-col
      class="text-center"
      cols="2"
    >
    <FooterLogsDialog />
    </v-col>
    <v-col
      class="text-center"
      cols="2"
    >
      <BackendFileStorageDetails />
    </v-col>
    <v-col
      class="text-center"
      cols="3"
    >
      <p class="font-weight-thin" style="cursor:pointer" @click="checkCacheHeaders">(ver: {{ buildVersion }})</p>
    </v-col>
  </v-footer>
</template>

<script>
import {
  mapGetters,
} from 'vuex';
import FooterLogsDialog from './FooterLogsDialog.vue';
import BackendFileStorageDetails from '../SystemInfo/BackendFileStorageDetails.vue';

export default {
  name: 'Footer',
  components: {
    FooterLogsDialog,
    BackendFileStorageDetails,
  },
  computed: {
    buildVersion() {
      if (process && process.env && process.env.VUE_APP_VERSION) {
        return process.env.VUE_APP_VERSION;
      }
      return 'unset';
    },
    ...mapGetters([
      'todaysDate',
    ]),
  },
  methods: {
    printScreen() {
      this.$emit('printScreen', true);
    },
    async checkCacheHeaders() {
      try {
        const res = await fetch('/index.html', { method: 'HEAD', cache: 'no-store' });
        const cc = res.headers.get('cache-control') || '(not set)';
        const pragma = res.headers.get('pragma') || '(not set)';
        // eslint-disable-next-line no-alert
        alert(`Cache-Control: ${cc}\nPragma: ${pragma}`);
      } catch (e) {
        // eslint-disable-next-line no-alert
        alert(`Failed to fetch headers: ${e.message}`);
      }
    },
  },
};
</script>
